import { render, staticRenderFns } from "./SOTDComponent.vue?vue&type=template&id=77ab6d3d&scoped=true&functional=true&"
import script from "./SOTDComponent.vue?vue&type=script&lang=js&"
export * from "./SOTDComponent.vue?vue&type=script&lang=js&"
import style0 from "./SOTDComponent.vue?vue&type=style&index=0&id=77ab6d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "77ab6d3d",
  null
  
)

export default component.exports